export default __webpack_public_path__ + "static/media/element_spec_70.e95e7345.webp";